module.exports = __webpack_public_path__ + "media/pricing/Business_PricingPage-77408755.png";